module.exports = __webpack_public_path__ + "static/media/default_2.c81aa81e.svg";